import React, { useContext } from 'react'
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import { CELEBRITY_CHEF_PNG } from '../../global/assets/Icons'
import { Rating, Avatar, Chip } from "@mui/material";
import FastfoodIcon from '@mui/icons-material/Fastfood';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';

const StoretitleCloudkitchen = () => {
    const { sortedKitchenData,
        activeButton, setActiveButton,
    } = useContext(OnTheMenuDataContext)

    console.log('---sortedKitchenData', sortedKitchenData)

    if (isMobile) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '2200px',
                backgroundColor: '#F8F8F8',
                height: 'auto',
                margin: '5px 0px 0px 0px',
                padding: '10px 10px 10px 10px',
                position: 'relative',


            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    border: '2px solid rgb(255, 137, 58)',
                    height: '220px',
                    // backgroundColor: 'rgb(254, 236, 190)',
                    backgroundColor: 'white',
                    borderRadius: '5px'
                }}>
                    <div style={{
                        position: 'absolute',
                        // right: '0px',
                        top: '-5px',
                        width: "11%",
                        overflow: 'hidden'
                    }}>
                        <img width="100%" src={CELEBRITY_CHEF_PNG}></img>

                    </div>

                    <div style={{
                        fontFamily: 'Inter Medium',
                        color: '#342870',
                        marginTop: '50px'
                    }}> Cloud Kitchen Name

                    </div>


                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '3px',
                        marginTop: '5px',
                    }}>
                        <FastfoodIcon sx={{ color: '#342870', fontSize: '12px', marginRight: '5px' }} />
                        <div style={{
                            fontSize: '14px',
                            fontFamily: 'Inter Bold', // Inter Medium Inter Bold  Inter Light Inter ExtraLight
                            letterSpacing: '0.5px',
                            color: '#342870'
                        }}>Combo bundle</div>

                        <Chip label='Extra Saving'
                            size='small'
                            sx={{
                                border: '1px solid #86c49a',
                                background: '#dff5cf',
                                color: '#06763f',
                                height: '20px',
                                fontSize: '11px',
                                fontFamily: 'Inter Light',
                                marginLeft: '5px'
                            }}
                        />

                    </div>

                    <div style={{
                        fontSize: '13px',
                        fontFamily: 'Inter Regular',
                        letterSpacing: '0.5px',
                        color: '#342870'
                    }}>
                        Brunch 4 Items  + Dinner 4 Items
                    </div>


                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '55px',
                            width: '55px',
                            border: '1px solid #342870',
                            backgroundColor: '#342870',
                            borderRadius: '5px',
                            color: 'white',
                            fontFamily: 'Inter Bold',
                            fontSize: '20px'
                        }}>
                            10

                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                            <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#342870' }}> <a style={{ color: '#86c49a', fontFamily: 'Inter Bold' }}>FREE</a> Delivery</div>
                            <div style={{ fontSize: '14px', fontFamily: 'Inter Medium', color: '#342870' }}> Arrives Tomorrow </div>
                            <div style={{ fontSize: '14px', fontFamily: 'Inter Regular', color: '#342870' }}>Between 10AM - 1PM</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }



    return (

        <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            border: '2px solid rgb(255, 137, 58)',
            height: '220px',
            backgroundColor: 'white',
            borderRadius: '5px',
            margin: '10px',
            width: '100%'
        }}>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <div style={{
                    width: '100px',
                    overflow: 'hidden',
                    // marginLeft: '10%'
                }}>
                    <img width="70%" src={CELEBRITY_CHEF_PNG}></img>
                </div>

                <div style={{
                    fontFamily: 'Inter Medium',
                    color: '#342870',
                    marginTop: '10px'
                }}> Cloud Kitchen Name

                </div>

            </div>


            <div style={{ marginLeft: '30px' }}>


                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '3px',
                    // marginTop: '5px',
                }}>
                    <FastfoodIcon sx={{ color: '#342870', fontSize: '20px', marginRight: '5px' }} />
                    <div style={{
                        fontSize: '16px',
                        fontFamily: 'Inter Bold', // Inter Medium Inter Bold  Inter Light Inter ExtraLight
                        letterSpacing: '0.5px',
                        color: '#342870'
                    }}>Combo bundle</div>

                    <Chip label='Extra Saving'
                        size='small'
                        sx={{
                            border: '1px solid #86c49a',
                            background: '#dff5cf',
                            color: '#06763f',
                            height: '20px',
                            fontSize: '12px',
                            fontFamily: 'Inter Light',
                            marginLeft: '5px'
                        }}
                    />

                </div>

                <div style={{
                    fontSize: '14px',
                    fontFamily: 'Inter Regular',
                    letterSpacing: '0.5px',
                    color: '#342870'
                }}>
                    Brunch 4 Items  + Dinner 4 Items
                </div>


                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '60px',
                        width: '60px',
                        border: '1px solid #342870',
                        backgroundColor: '#342870',
                        borderRadius: '5px',
                        color: 'white',
                        fontFamily: 'Inter Bold',
                        fontSize: '20px'
                    }}>
                        10

                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px' }}>
                        <div style={{ fontSize: '16px', fontFamily: 'Inter Bold', color: '#342870' }}> <a style={{ color: '#86c49a', fontFamily: 'Inter Bold' }}>FREE</a> Delivery</div>
                        <div style={{ fontSize: '16px', fontFamily: 'Inter Medium', color: '#342870' }}> Arrives Tomorrow </div>
                        <div style={{ fontSize: '16px', fontFamily: 'Inter Regular', color: '#342870' }}>Between 10AM - 1PM</div>
                    </div>
                </div>

            </div>







        </div >

    )
}

export default StoretitleCloudkitchen